// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3EEqm","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3mDSw","obliqueLine":"membershipbadge_obliqueLine__ciKNy"};